/** @link https://pages.git.i.mercedes-benz.com/dh-io-workbench/documentation/v7/foundations/icons/#usage */
export const iconSizeMap = {
  S: '12px',
  M: '16px',
  L: '24px', // Default
  XL: '32px',
} as const;

export type IconSize = keyof typeof iconSizeMap;
